import { render, staticRenderFns } from "./secondaryPages.vue?vue&type=template&id=acdfeb0e&scoped=true&"
import script from "./secondaryPages.vue?vue&type=script&lang=js&"
export * from "./secondaryPages.vue?vue&type=script&lang=js&"
import style0 from "./secondaryPages.vue?vue&type=style&index=0&id=acdfeb0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acdfeb0e",
  null
  
)

export default component.exports